export default {
  messages: {
    en: {},
    fr: {},
  },
};



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.i18n.js